module.exports = __webpack_public_path__ + "img/SA1.ebb1d229.png";